const PostTypeParser = (PostType) => {
  const types = {
    1: 'Oferta General',
    2: 'Vuelo Sencillo',
    3: 'Vuelo Redondo',
    4: 'Vuelo + Hotel',
    5: 'Oferta Hotel',
  };
  return types[PostType];
};

export default PostTypeParser;
